// extracted by mini-css-extract-plugin
export var brand = "_bc-9";
export var compact = "_bc-6";
export var extraSmall = "_bc-7";
export var icon = "_bc-0";
export var large = "_bc-4";
export var light = "_bc-1";
export var medium = "_bc-5";
export var outline = "_bc-b";
export var primaryDark = "_bc-a";
export var primaryLight = "_bc-8";
export var primaryModern = "_bc-c";
export var success = "_bc-2";
export var successSolid = "_bc-3";